module.exports = __webpack_public_path__ + "static/media/anatomia1.6d9fc61b.png";